import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { PublicFacilityResponse } from "@bw/shared/types/generated";

/**
 * One facility's detail (GET /facilities/{id}), read for its NAME on the catalog
 * + purchase headings (VenuePlanResponse carries no facility_name). Reuses the
 * SHARED booking.facility cache slot (the common queryClient key, not a
 * cross-module import) so arriving from the facility homepage is warm — the same
 * read, no duplicate fetch or flicker. Gated on a truthy facilityId.
 */
export function useMembershipFacility(facilityId: string | undefined) {
  return useQuery<PublicFacilityResponse>({
    queryKey: ["public-facility", facilityId ?? ""],
    queryFn: () => facilityApi.getPublic(facilityId as string),
    enabled: Boolean(facilityId),
  });
}
